import _ from 'lodash';
import { AnyAction } from 'redux';
import { entityCollectionDefaultState, EntityCollectionState } from '../entities/types/EntityCollectionState';
import { FAILURE_LANDINGPAGES, REQUEST_LANDINGPAGES, SUCCESS_LANDINGPAGES } from './actions';

/* Landingpages */
export function landingpagesReducer(
    state: EntityCollectionState<any> = entityCollectionDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_LANDINGPAGES:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_LANDINGPAGES: {
            return _.assign({}, state, {
                isFetching: false,
                items: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_LANDINGPAGES:
            return _.assign({}, state, { isFetching: false, items: undefined, error: action.error });
        default:
            return state;
    }
}
